<template>
	<div class="body-scroll-table">
		<slot ref="table" />
	</div>
</template>

<script>
	export default {
		name: 'BodyScrollTable',
	};
</script>

<style lang="scss" scoped>
	.body-scroll-table {
		overflow-x: auto;
		display: block;
		width: 100%;
		border: solid 1px #dfe6ee;

		&::v-deep {
			.body-scroll-table__scroller {
				display: block;
				width: 100%;
				overflow-x: hidden;
				overflow-y: scroll;
			}

			.body-scroll-table__thead-scroller {
				@extend .body-scroll-table__scroller;

				border-bottom: solid 1px #dfe6ee;
			}

			.body-scroll-table__tbody-scroller {
				@extend .body-scroll-table__scroller;
			}

			.table-main {
				width: 100%;
				table-layout: fixed;

				thead,
				tbody {
					th:first-child,
					td:first-child {
						border-left: 0;
					}

					th:last-child,
					td:last-child {
						border-right: 0;
					}
				}

				thead {
					tr:last-child th {
						border-bottom: 0;
					}
				}

				tbody {
					tr:first-child td {
						border-top: 0;
					}

					tr:last-child td {
						border-bottom: 0;
					}
				}
			}
		}
	}
</style>
